import * as angular from 'angular';

import { CommonModule } from '../common/common.module';
import { SignInInputComponent } from './sign-in-input/sign-in-input.component';
import { SignInComponent } from './sign-in.component';
import { SignInService } from './sign-in.service';
import { SignInTitleComponent } from './sign-in-title/sign-in-title.component';
import { SignInSsoButtonComponent } from './sign-in-sso-button/sign-in-sso-button.component';
import { SignInToggleOptionsComponent } from './sign-in-toggle-options/sign-in-toggle-options.component';
import { SharedUiModule } from '~/modules/shared-ui/shared-ui.module';

export const SignInModule = angular
  .module('sign-in', [CommonModule, SharedUiModule])
  .component('signIn', SignInComponent)
  .component('signInInput', SignInInputComponent)
  .component('signInTitle', SignInTitleComponent)
  .component('signInSsoButton', SignInSsoButtonComponent)
  .component('signInToggleOptions', SignInToggleOptionsComponent)
  .service('SignInService', SignInService).name;
